import { Pipe, PipeTransform } from '@angular/core';
import { SessionService } from '../../services/session/session.service';
import { FinanceTab } from './finance-tabs';

@Pipe({name: 'visibleFinanceTabs'})
export class VisibleFinanceTabsPipe implements PipeTransform {
  constructor(private sessionService: SessionService) {}

  transform(tabs: FinanceTab[]): FinanceTab[] {
    const exactSuperadmin = this.sessionService.isExactSuperAdmin();
    return (tabs || []).filter(tab => !tab.exactSuperadminOnly || exactSuperadmin);
  }
}
